import React from "react";

/**
 * Relationships nav icon. Uses `currentColor` (not a hardcoded stroke) and no
 * per-path stroke-width so it inherits color and stroke-width from the
 * `className` Sidebar applies (`text-gray-600`/`text-[#974ae4]`,
 * `stroke-[1.5]`), exactly like the lucide-react icons it sits alongside.
 */
export const RelationshipsIcon: React.FC<{
  className?: string;
  size?: number;
}> = ({ className, size }) => (
  <svg
    width={size ?? 20}
    height={size ? (size * 22) / 20 : 22}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17.3117 18C17.9361 18 18.4327 17.6071 18.8787 17.0576C19.7916 15.9328 18.2927 15.034 17.7211 14.5938C17.14 14.1463 16.4912 13.8928 15.8333 13.8333M15 12.1667C16.1506 12.1667 17.0833 11.2339 17.0833 10.0833C17.0833 8.93274 16.1506 8 15 8"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M2.69091 18C2.06648 18 1.56983 17.6071 1.12389 17.0576C0.211013 15.9328 1.70983 15.034 2.28147 14.5938C2.86258 14.1463 3.51142 13.8928 4.16927 13.8333M4.58594 12.1667C3.43535 12.1667 2.50261 11.2339 2.50261 10.0833C2.50261 8.93274 3.43535 8 4.58594 8"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M6.73911 15.5979C5.88762 16.1244 3.65509 17.1995 5.01486 18.5447C5.67909 19.2019 6.41887 19.6719 7.34896 19.6719H12.6563C13.5864 19.6719 14.3261 19.2019 14.9904 18.5447C16.3501 17.1995 14.1176 16.1244 13.2661 15.5979C11.2694 14.3632 8.73579 14.3632 6.73911 15.5979Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9193 9.24479C12.9193 10.8556 11.6135 12.1615 10.0026 12.1615C8.39179 12.1615 7.08594 10.8556 7.08594 9.24479C7.08594 7.63396 8.39179 6.32812 10.0026 6.32812C11.6135 6.32812 12.9193 7.63396 12.9193 9.24479Z"
      stroke="currentColor"
    />
  </svg>
);
